import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
  ResponsiveContainer,
  
} from "recharts";
import "./fundsChart.css";
import "../../common/css/component.css";

const rootStyles = getComputedStyle(document.documentElement);
const colors = [
    rootStyles.getPropertyValue("--chart-color-1").trim(),
    rootStyles.getPropertyValue("--chart-color-2").trim(),
    rootStyles.getPropertyValue("--chart-color-3").trim(),
    rootStyles.getPropertyValue("--chart-color-4").trim(),
    rootStyles.getPropertyValue("--chart-color-5").trim(),
    rootStyles.getPropertyValue("--chart-color-6").trim(),
  ];

const renderCustomizedLabel = (props, colorIndex) => {
    const { x, y, width, height, value } = props;
    const radius = 10;
    const formattedValue = value !== undefined ? `$${value.toLocaleString()}` : '';
  
    return (
      <text
        x={x + width / 2}
        y={y + height / 2}
        fill={rootStyles.getPropertyValue("--chart-text-color").trim()}
        textAnchor="middle"
        dominantBaseline="central"
      >
        {formattedValue}
      </text>
    );
  };

  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p><span className="bold-label">Fund Name:</span> {`${payload[0].payload.fund_name}`}</p>
          <p><span className="bold-label">Available Dry Powder:</span> {`${currencyFormatter.format(payload[0].payload.available_dry_powder)}`}</p>
          <p><span className="bold-label">Total Investments in Fund:</span> {`${currencyFormatter.format(payload[0].payload.total_investments_in_fund)}`}</p>
        </div>
      );
    }
    
    return null;
  };  

const FundsChart = ({ data }) => {
  if (!Array.isArray(data)) {
    return <div>No data available.</div>;
  }
  const formattedData = data.map((item) => ({
    ...item,
    total: item.total_investments_in_fund + item.available_dry_powder,
  }));

  return (
    <div className="component-container-no-border">
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={formattedData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="fund_name" />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Bar dataKey="available_dry_powder" name="Available Dry Powder" stackId="a" fill={colors[0]}>
              <LabelList dataKey="available_dry_powder" content={(props) => renderCustomizedLabel(props, 0)} />
          </Bar>
          <Bar dataKey="total_investments_in_fund" name="Total Investments In Fund" stackId="a" fill={colors[1]}>
              <LabelList dataKey="total_investments_in_fund" content={(props) => renderCustomizedLabel(props, 1)} />   
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default FundsChart;
